import React, { useState } from 'react';
import { Card, Form, Button, InputGroup } from 'react-bootstrap';
import LoadingSpinner from '../common/LoadingSpinner';
import { searchService } from '../../services/searchService';
import { useNavigate } from 'react-router-dom';

const AccountSearchCard = () => {
  const navigate = useNavigate();
  const [accountId, setAccountId] = useState('');
  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setAccountId(
      e.target.value.replace(/\D/g, '').slice(0, 10)
    );
    setError('');
    setValidated(false);
  }

  const handleAccountSearch = async (e) => {
    e.preventDefault();
    setValidated(true);
    setError('');

    if (!accountId || accountId.length !== 10) {
      setError('Account number must be exactly 10 digits.');
      return;
    }

    setLoading(true);
    try {
      const response = await searchService.searchByAccount(accountId);
      if (response.success) {
        navigate(`/customer/${accountId}`);
      } else {
        setValidated(false);
        setError(response.error || 'Customer not found.');
      }
    } catch (err) {
      setValidated(false);
      setError('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="shadow">
      <Card.Header>
        <h5 className="mb-0">Search by Account Number</h5>
      </Card.Header>

      <Card.Body>
        <Form noValidate validated={validated} onSubmit={handleAccountSearch}>
          <Form.Group className="mb-3">
            <InputGroup>
              <Form.FloatingLabel
                label="10-Digit Account Number"
                controlId="account-id"
              >
                <Form.Control
                  type="text"
                  value={accountId}
                  onChange={handleChange}
                  minLength={10}
                  maxLength={10}
                  required
                  placeholder=""
                  isInvalid={!!error}
                />
                <Form.Control.Feedback type="invalid">
                  {error}
                </Form.Control.Feedback>
              </Form.FloatingLabel>
            </InputGroup>
          </Form.Group>

          <Button
            type="submit"
            variant="primary"
            className="w-100"
            disabled={loading}
          >
            {loading ? (
              <LoadingSpinner inline message="Searching..." />
            ) : (
              'Search'
            )}
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default AccountSearchCard;